import { formatLocationAddress } from "../../../../../routes/Configuration/helpers";

// User address from the location names the API returns with it
// ("Settlement, City, County" - or the country name for foreign addresses)
export const constructAddress = address =>
  address ? formatLocationAddress(address, { withSettlement: true }) : null;



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/SendAddressModal/utils/constructAddress.ts